function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
var ReglaNotifDocComponentCtrl = /*#__PURE__*/function () {
  ReglaNotifDocComponentCtrl.$inject = ["$element", "$timeout", "$log", "NotifService", "AccesoDatos"];
  function ReglaNotifDocComponentCtrl($element, $timeout, $log, NotifService, AccesoDatos) {
    _classCallCheck(this, ReglaNotifDocComponentCtrl);
    _defineProperty(this, "dirty", false);
    _defineProperty(this, "edit", {
      estado: null,
      doc: null,
      mails: null,
      activanotif: false,
      todosdocs: false
    });
    this.$element = $element;
    this.$timeout = $timeout;
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(ReglaNotifDocComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[ReglaNotifDocComponentCtrl] onInit');
      this.estadosList = this.regla.estadosList;
      this.tiposDocGruposList = this.regla.tiposDocGruposList;
      this.edit.estado = this.regla.rule.estado;
      this.edit.doc = this.regla.rule.tipodoc;
      this.edit.mails = this.regla.mailsEnvioString();
      this.edit.activanotif = this.regla.notifActiva();
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this = this;
      // this.$timeout(() => (this.$element.find('select') as any).formSelect(), 100)

      this.$timeout(function () {
        var textarea = _this.$element.find('.materialize-textarea');
        if (textarea && textarea[0]) M.textareaAutoResize(textarea);
      }, 200);
    }
  }, {
    key: "update",
    value: function update() {
      var _this2 = this;
      var rule = Object.assign({}, this.regla.rule);
      rule.todosdocs = this.edit.todosdocs;
      rule.tipodoc = this.edit.doc;
      rule.estado = this.edit.estado;
      rule.activanotif = this.edit.activanotif;
      rule.mail = this.edit.mails;
      this.AccesoDatos.Documentacion_CLIENT.actualizaReglaNotifDocDoc(rule).then(function (ruleResponse) {
        _this2.regla.actualiza(ruleResponse);
        _this2.dirty = false;
      });
    }
  }]);
}();
angular.module('candidato').component('reglaNotifDoc', {
  bindings: {
    regla: '<'
  },
  controller: ReglaNotifDocComponentCtrl,
  // templateUrl: "regla-notif-doc.component.html",
  template: require('./regla-notif-doc.component.html')
});